export default __webpack_public_path__ + "static/media/privacy.f37553f4.txt";